<template>
  <portal to="modal-destination">
    <main class="modal">
      <div class="modal__overlay"></div>
      <div class="modal__content">
        <i
          @click="$emit('close')"
          class="helper float-right m-2 items-center border-0"
        >
          <FontAwesomeIcon icon="times" />
        </i>
        <header class="text-2xl font-bold text-primary pt-4 pl-8">
          <slot name="header" />
        </header>
        <div class="p-8">
          <slot name="body" />
        </div>
        <hr class="mb-4" />
        <footer class="pb-6 border-gray-200 px-8 flex justify-end">
          <slot name="footer" />
        </footer>
      </div>
    </main>
  </portal>
</template>

<script>
export default {
  name: 'ModalSlotted',
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.modal {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
  &__overlay {
    position: absolute;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.5);
  }
  &__content {
    z-index: 1;
    max-width: 90vw;
    min-width: 50vw;
    border-radius: 24px;
    background-color: white;
    overflow: hidden;
    position: relative;
    .helper-btn {
      position: absolute;
      right: 1rem;
      top: 1rem
    }
  }
}
</style>
